<template>
  <component :is="component" v-bind="$props" />
</template>

<script lang="ts">
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { defineComponent, computed } from "vue";

import WrapperBadges from "./WrapperBadges.vue";
import Wrapper from "./Wrapper.vue";

export default defineComponent({
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup() {
    const { teamBranding } = injectBrand() || ({} as BrandContext);
    const component = computed(() => {
      return teamBranding.value.useTeamBranding ? WrapperBadges : Wrapper;
    });

    return {
      component
    };
  }
});
</script>
